app.controller("SysParamController", ["$scope", "$uibModal", "SysParam",
    function ($scope, $uibModal, SysParam) {
        $scope.sysparams = [];

        function loadSysParams() {
            SysParam.sysParamList().then(function (data) {
                console.log(data);
                $scope.sysparams = data;
            });
        }

        loadSysParams();

        $scope.add = function () {
            $uibModal.open({
                controller: "AddSysparamController",
                templateUrl: _pb + 'sudo/sysparam/add-system-parameter.html',
                size: "md"
            }).result.then(function (result) {
                loadSysParams();
            }, function () {
            });
        };

        $scope.edit = function (sysParam) {
            $uibModal.open({
                controller: "EditSysparamController",
                templateUrl: _pb + 'sudo/sysparam/edit-system-parameter.html',
                size: "md",
                resolve: {
                    sysparam: function () {
                        return {
                            _id: sysParam._id,
                            name: sysParam.name,
                            description: sysParam.description,
                            type: sysParam.type,
                            value: sysParam.value
                        };
                    }
                }
            }).result.then(function (result) {
                loadSysParams();
            }, function () {
            });
        };
    }
]);